<template>
  <div class="bar-chart" :class="{ 'even': even, 'odd': !even }" :title="`${formattedNumber} / ${max}`">
    <div class="background">
      <div class="bar" :style="{ width: `${width}%` }" :data-value="value" :data-max="max"></div>
    </div>
    <label v-if="showValue">
      {{ formattedNumber }}
    </label>
  </div>
</template>

<script>

export default {
  name: 'BarChart',
  props: {
    // actual value (e.g. 30.2)
    value: {
      required: true,
      type: Number
    },
    // optional value to enforce the width of the bar
    // in case of separately normalized values that range from 0.0 to 1.0
    percentageValue: {
      required: false,
      type: Number,
      default: null
    },
    // optional text to place next to the chart
    showValue: {
      required: false,
      type: Boolean,
      default: true
    },
    max: {
      required: false,
      type: Number,
      default: 100
    },
    even: {
      required: false,
      type: Boolean,
      default: true
    }
  },
  computed: {
    formattedNumber() {
      if (this.value !== null) {
        if (this.value % 1 === 0) {
          return this.value.toFixed(0);
        }
        return this.value.toFixed(2)
      }
      return "-"
    },

    width() {
      // console.log("barchart render", this.value, "out of", this.max)
      if (this.percentageValue !== null) {
        return this.percentageValue * 100
      }
      return (this.value / this.max).toFixed(4) * 100
    }
  },
  methods: {
  }
}

</script>

<style lang="scss">
.bar-chart {
  display: flex;

  label {
    flex-basis: 60px;
    font-size: 14px; // about 0.9 rem.. but need to match the tailwind text-xs for now
    margin: 0 5px;
  }

  .background {
    flex: 1;
    position: relative;
    background: var(--gray-100);
    border-radius: 4px;
    overflow: hidden;
    margin: 1px 0;
    height: 25px;
    border-bottom: 1px solid var(--text-grey);

    @media print {
      overflow: visible;
    }

    .bar {
      height: 100%;
    }
  }

  &.even {
    .bar {
      background: var(--halsa-red);
      border: 1px solid var(--halsa-red);
      print-color-adjust: exact;
      -webkit-print-color-adjust: exact;
    }
  }

  &.odd {
    .bar {
      background: var(--halsa-blue);
      border: 1px solid var(--halsa-blue);
      print-color-adjust: exact;
      -webkit-print-color-adjust: exact;
    }
  }
}
</style>
